import { inject, Injectable } from '@angular/core';
import { Customer } from '@df/session/api/customer';
import * as Sentry from '@sentry/angular';
import { CaptureContext, EventHint, ScopeContext } from '@sentry/types';
import { NSentry } from './sentry.interfaces';
import { CustomerModel } from '@df/session/api/customer.model';
import { Basket } from '@df/session/api/basket/basket';
import { ProcessorService } from '@df/ng/processor.service';
@Injectable({
    providedIn: 'root'
})
export class SentryService {
    private oldUserDataString: string = '';
    private customer = inject(Customer);

    constructor() {
        ProcessorService.onReady(() => {
            if (Sentry.isInitialized()) {
                this.customer.model.obs.status.subscribe(() => this.updateUser());
                //for quote_id changes
                this.customer.basket.subscribe(() => this.updateUser());
                this.updateUser();
            }
        });
    }

    private updateUser(): void {
        const newUserData: NSentry.IUserData = {
            id: this.customer.model.data?.id,
            logged_in: this.customer.model.isLoggedIn,
            quote_id: this.customer.basket?.data?.quote_id
        };
        const newUserDataString = JSON.stringify(newUserData);
        if (newUserDataString !== this.oldUserDataString) {
            this.oldUserDataString = newUserDataString;
            Sentry.setUser(newUserData);
        }
    }

    captureException(
        error: any,
        hint?:
            | (CaptureContext &
                  Partial<{
                      [key in keyof EventHint]: never;
                  }>)
            | (EventHint &
                  Partial<{
                      [key in keyof ScopeContext]: never;
                  }>)
    ): void {
        Sentry.captureException(error, hint);
    }

    captureMessage(message: string, captureContext?: CaptureContext): void {
        Sentry.captureMessage(message, captureContext);
    }
}
